import React from 'react';
import './Bio.css';

export default function Bio() {
  return (
    <section id='bio' className='sectionStyles'>
      <h2>About Me</h2>
      <div className='itemStyles'>
        <p>
        I am an engineering pathways student at Elgin Community College. I graduated from Thinkful's Engineering Immersion Bootcamp, where I learned full-stack web development. Besides being a full-time student, I also love exercising, and more recently, I have built an interest in boxing. Math is another passion of mine. I work in the math tutoring center at my school and am also a tutor for high school students studying SAT math and calculus.
        </p>
        <div className='bioSpace' />
        {/* <p>
        
        </p> */}
      </div>
    </section>
  );
}
